export default __webpack_public_path__ + "static/css/email.css";